import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { CloseDialogButton } from '~/components/CloseDialogButton';
import { DeleteIcon } from '~/components/icons';
import { useAppDispatch, useAppSelector } from '~/redux';
import { removeImageError } from '~/redux/features/imageErrorsSlice';

import './ImageErrorDialog.css';

interface IImageErrorDialog {
  open: boolean,
  onClose: () => void
}

export const ImageErrorDialog: React.FC<IImageErrorDialog> = ({ open = false, onClose }) => {

  const dispatch = useAppDispatch();

  const errors = useAppSelector(state => state.imageErrors.errors);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const groupErrors = Object.groupBy(errors, error => error.message);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const groupKeys = Object.keys(groupErrors);

  const handleCancel = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    onClose();
  };
  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'xl'}
      onClose={(e, reason) => {
        reason === 'escapeKeyDown' && handleCancel(e as React.MouseEvent);
      }}
      PaperProps={{ sx: { minWidth: 300 } }}
    >
      <DialogTitle>
        <Typography color="error">
          Image Request Errors
        </Typography>
        <CloseDialogButton onClick={handleCancel} />
      </DialogTitle>
      <DialogContent>
        <ul style={{paddingLeft: 'revert'}}>
          {groupKeys.sort().map(key => (
            <li key={key}>{key}
              <ul className='ImageErrorDialog__sub_ul'>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                {groupErrors[key]?.sort().map((error, index: number) => (
                  <li key={`${error.message}_${index}`}>
                    <IconButton size="small" onClick={() => dispatch(removeImageError(error))} aria-label="delete">
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                    {error.path}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" variant="contained" size="small" onClick={handleCancel}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
